export default "__VITE_ASSET__Clj1Y12W__"